/* unplugin-vue-components disabled */import script from "./index_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./index_copy.vue?vue&type=script&setup=true&lang=js"

import "./index_copy.vue?vue&type=style&index=0&id=ad5b6dc6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad5b6dc6"]])

export default __exports__